import apiClient from "@/app/api/client";
import type { AttendanceTrend, DashboardPayload, RiskyEmployee } from "../types";

interface SingleResponse<T> {
	success: true;
	data: T;
}

/**
 * Dashboard API klienti.
 *
 * ⚠️ `GET /employees/risky` SAHIFALANMAGAN — javob `{ items }`,
 * `{ items, meta }` EMAS (backend `RiskyEmployeeListResponseSchema`
 * ataylab `createPaginatedSchema` ni ishlatmaydi: bayroqlangan xodim
 * kamdan-kam holat va rahbar hammasini bir ekranda ko'rishi kerak).
 */
export const dashboardApi = {
	/**
	 * ⚠️ `date` BERILMASA — parametr UMUMAN yuborilmaydi va server
	 * sozlangan zonadagi bugunni o'zi hisoblaydi. `{ date: undefined }`
	 * ham yaroqli (axios bo'sh parametrni tashlab yuboradi), lekin
	 * niyat aniq ko'rinishi uchun obyekt shartli quriladi.
	 */
	async get(date?: string): Promise<DashboardPayload> {
		const response = await apiClient.get<SingleResponse<DashboardPayload>>(
			"/attendance/dashboard",
			date ? { params: { date } } : undefined
		);

		return response.data.data;
	},

	/**
	 * Davomat trendi (sparkline seriyasi).
	 *
	 * ⚠️ `to` FAQAT sana tanlanganda yuboriladi — aks holda server
	 * SOZLANGAN zonadagi (`settings.timezone`) bugunni hisoblaydi,
	 * server OS zonasidagi emas (`get()` bilan AYNI qoida).
	 *
	 * ⚠️ `days` chegarasi backendda `min(2).max(90)`
	 * (`AttendanceTrendQuerySchema`) — chaqiruvchi `TREND_DAYS`
	 * konstantasini uzatadi, satr ichida raqam yozmaydi.
	 */
	async trend(days: number, to?: string): Promise<AttendanceTrend> {
		const response = await apiClient.get<SingleResponse<AttendanceTrend>>(
			"/attendance/dashboard/trend",
			{ params: to ? { days, to } : { days } }
		);

		return response.data.data;
	},

	async risky(): Promise<RiskyEmployee[]> {
		const response =
			await apiClient.get<SingleResponse<{ items: RiskyEmployee[] }>>("/employees/risky");

		return response.data.data.items;
	},

	async acknowledge(id: string, reason: string): Promise<void> {
		await apiClient.post(`/employees/${id}/risk/acknowledge`, { reason });
	},
};
